import {Model} from "ords/dist/model/model";

export class GroupPairGroups extends Model {
    getStatus(option) {

        if(this.accepted === 1){
            return 2;
        }

        switch (option) {
            case 1:
                return (this.check_teacher === 1 || this.check_teacher === 2)
                    ? this.check_teacher
                    : 3;
            case 2:
                if (this.check_teacher === 2 && this.check_coordinator === 2) {
                    return 2; // approved
                } else if (!this.check_teacher || !this.check_coordinator) {
                    return 3; // empty
                } else {
                    return 1; // redo
                }
            case 3:
                return (this.check_coordinator === 1 || this.check_coordinator === 2)
                    ? this.check_coordinator
                    : 3;
        }
        return undefined;
    }
}

export const GroupPairGroupsConfig = {
    name: 'group_pair_groups',
    model: GroupPairGroups,
    relations: [
        {name: 'group_pair_group_teachers', model_name: 'group_pair_group_teachers', type: 'hasMany'},
        {name: 'group_pair_students', model_name: 'group_pair_students', type: 'hasMany'},
        {name: 'group_pair_group_courses', model_name: 'group_pair_group_courses', type: 'hasMany'},
    ]
}
